export default "__VITE_ASSET__3b5ecfb0__"